import React from 'react';
import clsx from 'clsx';

import { injectedComponent } from '@base/core';

function includes(content, substr){
  if(typeof content == "string"){
    return content.includes(substr)
  }
  if(typeof content == "object" && content.$$typeof && content.$$typeof.toString()=='Symbol(react.element)'){
    return content.props.children && content.props.children.join("").includes(substr)
  }
  return false
}

export default injectedComponent(
  {
    name: 'PopUpNotification',
    styles: ['popup'],
  },
  function PopUpNotification({
    id,
    content,
    fade,
    handler,
    onClose,
    notificationStyle,
    hideButton,
    styles: { popup: popupStyles },
  }) {
    const handleClick = () => {
      typeof handler === 'function' && handler();
      onClose(id);
    };

    return (
      <div
        className={clsx(popupStyles.notification, {
          [popupStyles.notificationFade]: fade,
        })}
      >
        <span className={popupStyles.text} style={notificationStyle || {}}>
          {content}
        </span>
        {!hideButton && (
          <button className={popupStyles.button} onClick={handleClick}>
            {(content && includes(content, 'Обнаружена незавершенная регистрация'))? 'Продолжить' : 'Ok'}
          </button>
        )}
      </div>
    );
  }
);
